const UserAction = {
  CANCEL: 'CANCEL',
};
export const AddressForm = {
  showDeliveryAddressForm: (viewModel) => {
    window.DeliveryAddressForm.render(getDeliveryFormDefaultParams(viewModel));
  },
};

const getDeliveryFormDefaultParams = (viewModel) => {
  const {
    address = {},
    sameAsShipping,
    unknownCity,
  } = viewModel.sectionsModel.shipping.data;
  const countryShortName =
    viewModel.countrySelects.shipping.selectedCountry.code;

  let defaultValues = { sameAsShipping: true, countryShortName };
  const isEditAddressMode = viewModel.sectionsModel.shipping.data.isNotEmpty;
  if (isEditAddressMode) {
    defaultValues = { ...address, sameAsShipping };
  }

  const showCancelButton = !!viewModel.sectionsModel.shipping.hasCancelButton;

  return {
    elementId: 'delivery-address-form-container',
    hiddenFields: {
      selectedType: 'NORMAL_ADDRESS',
    },
    formAttributes: {
      showCancelButton: showCancelButton,
      consumerName: 'registration',
    },
    defaultValues: defaultValues,
    callback: (data) => {
      handleAddressFormData(data, viewModel);
    },
    error: {
      unknownCityError: unknownCity,
    },
  };
};

const handleAddressFormData = (callbackData, viewModel) => {
  const { action, payload } = callbackData;
  if (action === UserAction.CANCEL) {
    viewModel.setAddressFlow();
    return;
  }

  storeDataToAngularModel(viewModel, payload);
  viewModel.setAddressFlow();
};

const storeDataToAngularModel = (viewModel, payload) => {
  viewModel.shippingForm = {};
  viewModel.shippingForm.$submitted = true;

  const {
    phoneNumber,
    additionalInformation,
    countryShortName,
    countryCode,
    country,
  } = payload;
  viewModel.shippingPhoneNumber = phoneNumber;
  viewModel.countrySelects.shipping.selectedCountry = {
    name: country,
    iso3166Name: countryCode,
    code: countryShortName,
  };

  viewModel.sectionsModel.shipping.data.sameAsShipping = payload.sameAsShipping;
  viewModel.sectionsModel.shipping.data.selectedType = 'NORMAL_ADDRESS';

  payload.company = additionalInformation;
  viewModel.sectionsModel.shipping.data.address = payload;
  viewModel.sectionsModel.shipping.data.isNotEmpty = true;
};
